<template>
  <b-table :items="memberships" :fields="fields" no-border-collapse outlined hover striped show-empty responsive class="table-container" head-variant="light">
    <template #cell(id)="data">
      <span class="typo-color-blue cursor-pointer">
        <a :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.id}`)" target="_blank">
          {{ data.item.id }}
        </a>
      </span>
    </template>
    <template #cell(program_name)="data">
      <router-link :to="{ name: programLegacyURL(data.item.program_type, true), params: { id: data.item.program_id }}">
        <span class="typo-color-blue cursor-pointer">
          {{ data.item.program_name }}
        </span>
      </router-link>
    </template>
    <template #cell(allow_registration)="data">
      <i v-if="data.item.accepted" class="fas fa fa-check m-auto"></i>
      <span v-else>Not Allowed</span>
    </template>
    <template #cell(accepted)="data">
      <i v-if="data.item.accepted === true" class="fas fa fa-thumbs-up m-auto" style="color:green" />
      <i v-else-if="data.item.accepted === false" class="fas fa fa-thumbs-down m-auto" style="color:red" />
      <span v-else-if="data.item.accepted === null">--</span>
    </template>
    <template #cell(registration_date)="data">
      <span class="text-nowrap" v-if="data.item.registration_date">
        {{ moment(data.item.registration_date, 'YYYY-MM-DD').format('MMM Do, YYYY') }}
      </span>
      <span v-else>--</span>
    </template>
    <template #cell(action)="data">
      <span class="text-nowrap">
        <span class="visit-count">{{ data.item.visit_count }}</span>
        <a
          :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.id}/visits`)"
          target="_blank"
        >
          <i v-b-tooltip.hover.top="'Scheduled visits'" class="fa fa-briefcase cursor-pointer typo-color-blue" />
        </a>
        <span v-if="data.item.only_visit">
          <i v-b-tooltip.hover.left="'Member already has one ONLY visit and can not be added more. Click on Visits icon to go to the visit page to edit current visit if you need to.'"
            class="fa fa-plus-circle"
            style="color:#aaa"
          />
        </span>
        <span v-else>
          <a :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.id}/visits/new`)" target="_blank">
            <i
              v-b-tooltip.hover.top="'Add new visit'"
              class="fa fa-plus-circle cursor-pointer"
              style="color:#e2562b"
            />
          </a>
        </span>
        <a
          :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.id}/edit`)"
          target="_blank"
        >
          <i v-b-tooltip.hover.top="'Edit'" class="fa fa-edit cursor-pointer custom-fa-edit-color"/>
        </a>
      </span>
    </template> 
  </b-table>
</template>

<script>
import mixin from "@/utils/mixin.js"

export default {
	name: "ProgramMemberships",
	props: ["memberships"],
	mixins: [mixin],
	data() {
		return {
			fields: [
				{
					key: "id",
					label: "Member ID",
				},
				{
					key: "program_name",
					label: "Program Name",
				},
				{
					key: "member_roles",
					label: "Member Role",
				},
				{
					key: "allow_registration",
					label: "Can Register?",
				},
				{
					key: "accepted",
					label: "Accepted?",
				},
				{
					key: "registration_date",
					label: "Reg Date",
				},
				{
					key: "action",
					label: "",
				},
			],
		}
	},
}
</script>

<style scoped>
.visit-count {
  background-color: #aaa;
  color: #fff;
  padding-inline: 5px;
  border-radius: 3px;
  font-size: 12px;
}
</style>